module.exports = __webpack_public_path__ + "img/4.5c2cf9a6.jpg";